var pattern = /^[a-z0-9][a-z0-9\-_ ]{1,63}$/;

// check if on node, else expose on browser's global window object
var isBrowser = true;
if (typeof window === 'undefined') {
    isBrowser = false;
}

var sigma = {
    version: 20160419,
    baseUrl: isBrowser ? '//' + window.location.host + '/api/sigma' : 'https://www.renrenche.com/api/sigma',
    ipAddress: null,
    userAgent: null,
    timeout: 1500,
    persist: true,
    environment: {},
    cookiePrefix: 'sigma-',
    cookieDomain: isBrowser ? window.location.hostname : '.renrenche.com',
};

// steal from http://stackoverflow.com/questions/105034
sigma.generateClientId = function () {
    var client = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });

    this.setCookie('client-uuid', client);

    return client;
};

sigma.setCookie = function (key, value) {
    if (isBrowser && this.persist) {
        var cookieExpire = new Date();
        cookieExpire.setTime(cookieExpire.getTime() + 10 * 365 * 24 * 60 * 60 * 1000);      // 10 years
        var cookieValue = this.cookiePrefix + key + '=' + value + '; expires=' + cookieExpire.toGMTString() + '; path=/';
        if (this.cookieDomain) {
            cookieValue += '; domain=' + this.cookieDomain;
        }
        document.cookie = cookieValue;
    }
};

// steal from http://stackoverflow.com/questions/5639346/shortest-function-for-reading-a-cookie-in-javascript
sigma.getCookie = function (key) {
    if (isBrowser) {
        var result = new RegExp('(?:^|; )' + encodeURIComponent(this.cookiePrefix + key) + '=([^;]*)').exec(document.cookie);
        return result ? (result[1]) : null;
    }

    return null;
};

sigma.Session = function (options) {
    Object.assign(this, sigma, options);

    if (!this.client) {
        if (this.persist && isBrowser) {
            var persistedId = this.getCookie('client-uuid');
            this.client = persistedId !== null ? persistedId : this.generateClientId();
        } else {
            this.client = this.generateClientId();
        }
    }
};

sigma.Session.prototype = {
    participate: function (data, callback) {
        data = data || {};

        // validate params
        if (!callback) {
            throw new Error('sigma.participate: Callback is not specified');
        }

        if (!data.experiment || !pattern.test(data.experiment)) {
            return callback(new Error('Bad experiment name'));
        }

        if (!data.variants || data.variants.length < 2) {
            return callback(new Error('Must specify at least 2 variants'));
        }

        for (var i = 0; i < data.variants.length; i += 1) {
            if (!pattern.test(data.variants[i])) {
                return callback(new Error('Bad variant name: ' + data.variants[i]));
            }
        }

        // rewrite variant assignment cookie on done
        // TODO use cookie if possible
        var instance = this;
        var done = function (err, res) {
            var experiments = instance.getCookie.call(instance, 'experiments');
            experiments = experiments ? experiments : '{}';
            try {
                experiments = JSON.parse(experiments);
            } catch (e) {
                experiments = {};
            }

            if (res.experiment && res.variant) {
                experiments[res.experiment] = err ? 'participate-error' : res.variant;
            } else {
                experiments[data.experiment] = 'participate-error';
            }

            instance.setCookie.call(instance, 'experiment', JSON.stringify(experiments));
            callback(err, res);
        };

        // try to parse `force` param from query string
        if (isBrowser && data.force == null) {      // eslint-disable-line eqeqeq
            var regex = new RegExp('[\\?&]sigma-force-' + data.experiment + '=([^&#]*)');
            var results = regex.exec(window.location.search);
            if (results != null) {      // eslint-disable-line eqeqeq
                data.force = decodeURIComponent(results[1].replace(/\+/g, ' '));
            }
        }

        // fast return on valid `force`
        if (data.force != null && _isInArray(data.variants, data.force)) {      // eslint-disable-line eqeqeq
            return done(null, {
                status: 0,
                variant: data.force,
                experiment: data.experiment,
                client: this.client,
            });
        }

        var traffic = typeof data.traffic === 'object' ? data.traffic : {};
        var environment = typeof data.environment === 'object' ? data.environment : null;
        var params = { client: this.client, experiment: data.experiment, variants: data.variants, traffic: traffic };
        if (this.ipAddress) {
            params.ipAddress = this.ipAddress;
        }
        if (this.userAgent) {
            params.userAgent = this.userAgent;
        }
        if (environment) {
            params.environment = environment;
        } else if (this.environment) {
            params.environment = this.environment;
        }

        // make a jsonp request
        return _request(this.baseUrl + '/participate', params, this.timeout, function (err, res) {
            if (err) {
                res = { status: -100, errmsg: err, variant: data.variants[0], experiment: data.experiment };
            }

            return done(err, res);
        });
    },

    convert: function (data, callback) {
        if (typeof data === 'string') {
            data = { experiment: data };
        }
        if (!callback) {
            callback = function (err) {
                if (err && console && console.error) {
                    console.error(err);
                }
            };
        }

        if (!data.experiment || !pattern.test(data.experiment)) {
            return callback(new Error('Bad experiment name'));
        }

        var params = { client: this.client, experiment: data.experiment };
        if (this.ipAddress) {
            params.ipAddress = this.ipAddress;
        }
        if (this.userAgent) {
            params.userAgent = this.userAgent;
        }
        if (this.environment) {
            params.environment = this.environment;
        }

        return _request(this.baseUrl + '/convert', params, this.timeout, function (err, res) {
            if (err) {
                res = { status: -100, errmsg: err };
            }
            return callback(null, res);
        });
    }
};

var _request = function (uri, params, timeout, callback) {
    var hasTimedOut = false;
    var timer = setTimeout(function () {
        hasTimedOut = true;
        return callback(new Error('request timed out'));
    }, timeout);

    var args = { params: JSON.stringify(params) };
    if (isBrowser) {
        args.callback = 'sigmajsonpcallback' + ((new Date).getTime());
        window[args.callback] = function (res) {
            if (!hasTimedOut) {
                clearTimeout(timer);
                return callback(null, res);
            }
        };
    }

    var url = _buildQueryString(uri, args);
    if (isBrowser) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
    } else {
        var http = require('http');
        var req = http.get(url, function (res) {
            var body = '';
            res.on('data', function (chunk) {
                body += chunk;
                return body;
            });
            return res.on('end', function () {
                var data;
                if (res.statusCode === 500) {
                    data = { status: -100, errmsg: body };
                } else {
                    data = JSON.parse(body);
                }
                if (!hasTimedOut) {
                    clearTimeout(timer);
                    return callback(null, data);
                }
            });
        });
        req.on('error', function (err) {
            if (!hasTimedOut) {
                clearTimeout(timer);
                return callback(err);
            }
        });
    }
};

var _buildQueryString = function (endpoint, args) {
    var queryString = [];
    for (var key in args) {
        if (args.hasOwnProperty(key)) {
            var vals = args[key];
            if (Object.prototype.toString.call(vals) !== '[object Array]') {
                vals = [vals];
            }
            for (var i = 0; i < vals.length; i += 1) {
                queryString.push(encodeURIComponent(key) + '=' + encodeURIComponent(vals[i]));
            }
        }
    }

    if (queryString.length) {
        endpoint += '?' + queryString.join('&');
    }

    return endpoint;
};

var _isInArray = function (a, v) {
    for (var i = 0; i < a.length; i++) {
        if (a[i] === v) {
            return true;
        }
    }
    return false;
};

